export enum EDropdownPlacement {
  Inline = 'inline',
  Fixed = 'fixed',
  Absolute = 'absolute',
}
